import { useEffect, useState } from "react";
import { Link } from "react-router-dom";

export const Navigation = () => {
  const [scrolled, setScrolled] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 20);
    onScroll();
    window.addEventListener("scroll", onScroll, { passive: true });
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  const scrollTo = (id) => {
    const el = document.getElementById(id);
    if (el) el.scrollIntoView({ behavior: "smooth", block: "start" });
  };

  return (
    <nav
      data-testid="numa-nav"
      className={`fixed top-0 left-0 right-0 z-50 transition-colors duration-500 ${
        scrolled
          ? "bg-[#F9F9F6]/85 backdrop-blur-md border-b border-[#E2E5E0]"
          : "bg-transparent"
      }`}
    >
      <div className="max-w-7xl mx-auto px-6 sm:px-8 lg:px-12 h-16 flex items-center justify-between">
        <button
          data-testid="nav-logo"
          onClick={() => window.scrollTo({ top: 0, behavior: "smooth" })}
          className="font-heading text-[15px] tracking-[0.42em] font-medium text-[#152219]"
        >
          NUMA
        </button>

        <div className="hidden md:flex items-center gap-10">
          {[
            ["protocol", "Protocol"],
            ["ingredients", "Ingredients"],
            ["delivery", "Delivery"],
            ["philosophy", "Mission"],
          ].map(([id, label]) => (
            <button
              key={id}
              data-testid={`nav-link-${id}`}
              onClick={() => scrollTo(id)}
              className="text-[12px] tracking-[0.2em] uppercase text-[#57635A] hover:text-[#152219] transition-colors duration-300"
            >
              {label}
            </button>
          ))}
          <Link
            to="/science"
            data-testid="nav-link-science"
            className="text-[12px] tracking-[0.2em] uppercase text-[#57635A] hover:text-[#152219] transition-colors duration-300"
          >
            Science
          </Link>
        </div>

        <button
          data-testid="nav-waitlist-cta"
          onClick={() => scrollTo("waitlist")}
          className="text-[12px] tracking-[0.2em] uppercase border border-[#152219] text-[#152219] px-5 py-2.5 hover:bg-[#152219] hover:text-[#F9F9F6] transition-colors duration-500"
        >
          Waitlist
        </button>
      </div>

      {/* Mobile sub-row: Science link visible on small screens */}
      <div className="md:hidden flex items-center justify-center gap-6 h-9 border-t border-[#E2E5E0] bg-[#F9F9F6]/85">
        <Link
          to="/science"
          data-testid="nav-link-science-mobile"
          className="text-[11px] tracking-[0.22em] uppercase text-[#57635A]"
        >
          Science
        </Link>
        <span className="h-3 w-px bg-[#E2E5E0]" />
        <button
          onClick={() => scrollTo("ingredients")}
          className="text-[11px] tracking-[0.22em] uppercase text-[#57635A]"
        >
          Ingredients
        </button>
      </div>
    </nav>
  );
};

export default Navigation;
